import { useState, useEffect } from 'react';
import InputText from '../../components/InputText';
import {getLocality} from '../../utilities/httpRequest';

export default function Form4({ hidden, analyses, bilans, matrix, data,setData,validationLabel,setValidationLabel, handleNext, cost, activePrescriber,countries,species,animalSex,sterilisationStatus }) {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData)=>({
            ...prevData,
            [name]: value
        }));
        setValidationLabel((prevData)=>({
            ...prevData,
            [name]: ""
        }))
    }

    const ActivePrescriber = () => {

        if (activePrescriber) {
            return (
                <div className="border-b border-light-gray flex items-center justify-center p-2">
                    <h1 className="text-base">PRESCRIPTEUR ACTIF:</h1>
                    <p className="italic text-dark-green ml-3">{activePrescriber.individual.first_name + activePrescriber.individual.last_name + " - " + activePrescriber.individual.email}</p>
                </div>
            )
        }
    }

    const [locality,setLocality] = useState("");
    useEffect(()=>{
        const id = data.petOwner.address.getLocalityId();
        if(id){
            const getLoc = async () =>{
                const locality_tmp = await getLocality(id);
                setLocality(locality_tmp);
            }
            getLoc();
        }
    },[data.petOwner.address.getLocalityId()])



    return (
        <div className={hidden ? "hidden" : "flex flex-row flex-wrap mx-5 gap-5"}>
            <div className="box-container max-w-[1000px] max-h-[700px] min-h-[600px] min-w-[500px] overflow-hidden flex flex-col flex-1">
                <ActivePrescriber />
                {activePrescriber ? "" : <h1 className="text-base border-b border-light-gray p-3">Récapitulatif</h1>}
                <div className="gap-3 p-3">
                    <div className="labeled-container-div border-light-green grid grid-cols-[1fr_3fr]">
                        <p className="labeled-container-p">Propriétaire</p>
                        <p className="font-medium text-md text-dark-green">Facturation: </p><p>{data.billingPrescriber ? "Au prescripteur" : "Au propriétaire de l'animal"}</p>
                        <p className="font-medium text-md text-dark-green">Nom:</p><p>{data.petOwner.name}</p>
                        <p className="font-medium text-md text-dark-green">Prénom: </p><p>{data.petOwner.firstname}</p>
                        <p className="font-medium text-md text-dark-green">Email:</p><p>{data.petOwner.email}</p>
                        <p className="font-medium text-md text-dark-green">Téléphone:</p><p>{data.petOwner.phone}</p>
                        <p className="font-medium text-md text-dark-green">Société:</p><p>{data.petOwner.company_name}</p>
                        <p className="font-medium text-md text-dark-green">TVA:</p><p>{data.petOwner.vat}</p>
                        <p className="font-medium text-md text-dark-green">Adresse:</p><p>{data.petOwner.address.getCompleteStreetString()}</p>
                        <p className="font-medium text-md text-dark-green">Localité:</p><p>{locality.postal_code || ""} {locality.label ||""}</p>
                        <p className="font-medium text-md text-dark-green">Pays:</p><p>{countries.find((country)=>country.id===locality.country)?.label || ""}</p>
                    </div>

                    <div className="flex flex-row gap-3">
                        <div className="labeled-container-div border-light-green grid grid-cols-[1fr_2fr] grow">
                            <p className="labeled-container-p">Animal</p>
                            <p className="font-medium text-md text-dark-green">Nom de l'animal:</p><p>{data.pet.name}</p>
                            <p className="font-medium text-md text-dark-green">ID Chip:</p><p>{data.pet.chip}</p>
                            <p className="font-medium text-md text-dark-green">Espèce:</p><p>{data.pet.getSpecie(species).label}</p>
                            <p className="font-medium text-md text-dark-green">Race:</p><p>{data.pet.getBreedNameSync()}</p>
                            <p className="font-medium text-md text-dark-green">Date de naissance:</p><p>{data.pet.getBirthDateAsString()}</p>
                            <p className="font-medium text-md text-dark-green">Sexe:</p><p>{data.pet.getSex(animalSex).label}</p>
                            <p className="font-medium text-md text-dark-green">Stérilisation:</p><p>{data.pet.getSterilisation(sterilisationStatus).label}</p>
                        </div>
                        <div className="labeled-container-div border-light-green grow-0 pl-3 pr-6 py-3">
                            <p className="labeled-container-p">Matériel</p>
                            <RecapMatrix analyses={analyses} matrix={matrix} bilans={bilans} />
                        </div>
                    </div>
                </div>


            </div>
            <div className="box-container overflow-hidden min-w-80 max-w-80 max-h-[700px] min-h-[600px] flex-1 flex flex-col justify-start">
                <h1 className="text-base border-b border-light-gray p-3">Validation</h1>
                <div className="overflow-y-auto">
                    <div className="labeled-container-div border-light-green mx-3 p-3">
                        <p className="labeled-container-p">Numéro de dossier</p>
                        <p className="">Veuillez inscrire ci-dessous le numéro de l'étiquette dossier:</p>
                        <InputText validationLabel={validationLabel.orderNb} name="orderNb" value={data.orderNb} placeholder="Numéro d'étiquette" onChange={handleChange} />
                    </div>
                    <div className="labeled-container-div border-light-green mx-3 p-3 mb-3">
                        <p className="labeled-container-p">Récapitulatif</p>
                        <div className="flex flex-col">
                            <h2 className="text-sm mb-1">Analyses</h2>
                            <table className="divide-y divide-light-gray text-sm">
                                <tbody>
                                    {analyses.map((category) => (category.bilans.map((bilan) => (bilan.checked ? <tr key={bilan.id}><td>{bilan.label}</td><td className="min-w-14">{bilan.price.toFixed(2)} €</td></tr> : ""))))}
                                    {analyses.map((category) => (category.analyses.map((analyse) => (analyse.checked ? <tr key={analyse.id}><td>{analyse.label}</td><td className="min-w-14">{analyse.price.toFixed(2)} €</td></tr> : ""))))}
                                </tbody>
                            </table>
                            <h2 className="text-sm mt-2 mb-1">Bilans</h2>
                            <table className="divide-y divide-light-gray text-sm">
                                <tbody>
                                    {bilans.map((bilan) => (bilan.checked ? <tr key={bilan.id}><td>{bilan.label}</td><td className="min-w-14">{bilan.price.toFixed(2)} €</td></tr> : ""))}
                                </tbody>
                            </table>
                        </div>
                        <div className="flex flex-col items-end border-t border-dark-green mt-2">
                            <h2 className="text-sm">TOTAL (HTVA): {cost.toFixed(2)} €</h2>
                            <h2 className="text-sm">TOTAL (TVAC 21%): {(cost + Math.round(cost * 100 * 0.21) / 100).toFixed(2)} €</h2>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center items-center bg-red min-h-16 max-h-16 mt-auto text-white font-medium text-lg cursor-pointer" onClick={handleNext}>Confirmer</div>
            </div>
        </div>
    );
}
function RecapMatrix({ analyses, matrix, bilans }) {

    const [selectedMatrix, setSelectedMatrix] = useState([]);

    useEffect(() => {
        const matrixFromId = (id) => {

            let tempItem;
            matrix.forEach((item) => {
                if (id === item.id) {
                    tempItem = item;
                }
            })
            return tempItem;
        }
        const matrixFromAnalyses = () => {
            let selected = [];
            analyses.forEach((category) => {
                category.analyses.forEach((item) => {
                    if (item.checked) {
                        item.matrix.forEach((mat) => {
                            const tempMat = matrixFromId(mat);
                            if (!selected.includes(tempMat)) {
                                selected.push(tempMat);
                            }
                        })
                    }
                })
                category.bilans.forEach((item) => {
                    if (item.checked) {
                        item.matrix.forEach((mat) => {
                            const tempMat = matrixFromId(mat);
                            if (!selected.includes(tempMat)) {
                                selected.push(tempMat);
                            }
                        })
                    }
                })
                bilans.forEach((item) => {
                    if (item.checked) {
                        item.matrix.forEach((mat) => {
                            const tempMat = matrixFromId(mat);
                            if (!selected.includes(tempMat)) {
                                selected.push(tempMat);
                            }
                        })
                    }
                })
            })
            setSelectedMatrix(selected);
        }
        matrix.length > 0 && matrixFromAnalyses();
    }, [analyses, bilans,matrix]);


    return (
        <ul className="flex flex-col">
            {selectedMatrix.map((item) => {
                return (<li key={item.code} className="flex flex-row items-center"><img alt="" className="size-4 mx-2" src={item.image}></img><p className="text-dark-green font-medium text-sm">{item.label !== "" ? item.label : item.code}</p> </li>);
            })}
        </ul>
    );
}
